const ChainedBackend = require('i18next-chained-backend').default;
const HttpBackend = require('i18next-http-backend/cjs');
const LocalStorageBackend = require('i18next-localstorage-backend').default;

const isBrowser = typeof window !== 'undefined';

const I18N_NEXT_COOKIE = 'next-i18next';
const DEFAULT_LANGUAGE = 'en-GB';

const getLng = () => {
    try {
        const cookies = document.cookie.split(';');
        const targetCookie = cookies.find((cookie) => {
            const [name] = cookie.trim().split('=');
            return name === I18N_NEXT_COOKIE;
        });

        if (targetCookie) {
            const [, value] = targetCookie.trim().split('=');
            if (value) {
                return decodeURIComponent(value);
            }
        }
    } catch {
        // Fallback to default if cookie parsing fails
    }
    return DEFAULT_LANGUAGE;
};

/** @type {import('next-i18next').UserConfig} */
module.exports = {
    backend: {
        backendOptions: [
            { expirationTime: 60 * 60 * 1000 },
            {
                loadPath: '/static/locales/{{lng}}/{{ns}}.json'
            }
        ],
        backends: isBrowser ? [LocalStorageBackend, HttpBackend] : []
    },
    compatibilityJSON: 'v3',
    defaultNS: 'translations',
    fallbackLng: {
        'de-AT': ['de-CH', DEFAULT_LANGUAGE],
        'de-DE': ['de-CH', DEFAULT_LANGUAGE],
        'de-LI': ['de-CH', DEFAULT_LANGUAGE],
        'de-LU': ['de-CH', DEFAULT_LANGUAGE],
        'fr-BE': ['fr-FR', DEFAULT_LANGUAGE],
        'fr-CA': ['fr-FR', DEFAULT_LANGUAGE],
        'fr-CH': ['fr-FR', DEFAULT_LANGUAGE],
        'fr-LU': ['fr-FR', DEFAULT_LANGUAGE],
        'fr-MU': ['fr-FR', DEFAULT_LANGUAGE],
        'it-CH': ['it-IT', DEFAULT_LANGUAGE],
        'en-US': [DEFAULT_LANGUAGE],
        de: ['de-CH'],
        default: [DEFAULT_LANGUAGE],
        en: [DEFAULT_LANGUAGE],
        fr: ['fr-FR'],
        it: ['it-IT'],
        nl: ['nl-NL'],
        sv: ['sv-SE']
    },
    partialBundledLanguages: true,
    i18n: {
        defaultLocale: DEFAULT_LANGUAGE,
        locales: [DEFAULT_LANGUAGE, 'de-CH', 'fr-FR', 'it-IT', 'nl-NL', 'sv-SE'],
        localeDetection: false
    },
    keySeparator: '::',
    lng: getLng(),
    load: 'currentOnly',
    localePath: './public/static/locales',
    ns: ['translations'],
    nsSeparator: '>>',
    reloadOnPrerender: process.env.NODE_ENV === 'development',
    returnEmptyString: false,
    serializeConfig: false,
    use: isBrowser ? [ChainedBackend] : []
};
